import axios from 'axios'
import store from '..'
import qs from 'querystring'

const AUTHAPI_BASEURL = process.env.VUE_APP_AUTHAPI_BASEURL

const mutations = {}

const actions = {
  /**
   * 初期パスワード変更アクション
   */
  async changeInitialPassword({commit, dispatch}, {userId, passwordBefore, passwordAfter}) {
    try {
      const result = await changeInitialPassword(userId, passwordBefore, passwordAfter)
      if (!result.error) {
        // サインインミューテーション実行
        store.commit('auth/signIn', result)
        // IDトークンリフレッシュアクション実行
        store.dispatch('auth/setIdTokenRefreshTimer')
        return 0
      } else {
        // userIdまたは変更前パスワード不正時
        return 1
      }
    } catch (err) {
      return 9
    }
  },
  /**
   * 初期パスワード変更アクション
   */
  async passwordInitialization({commit, dispatch}, {userId, mailAddress}) {
    try {
      const result = await passwordInitialization(userId, mailAddress)
      if (!result.error && result.success) {
        return 0
      } else {
        // userIdまたは変更前パスワード不正時
        return 1
      }
    } catch (err) {
      return 9
    }
  }
}

export default {
  namespaced: true,
  mutations,
  actions
}

/**
 * 初期パスワード変更処理
 * @param {string} userId  ユーザーID
 * @param {string} passwordBefore 変更前パスワード
 * @param {string} passwordAfter 変更後パスワード
 * @returns {Object} サインインAPIレスポンス
 */
const changeInitialPassword = async (userId, passwordBefore, passwordAfter) => {
  const $http = axios.create({
    baseURL: AUTHAPI_BASEURL,
    headers: {'Content-Type': 'application/json'},
    timeout: 15000
  })
  const parameters = {
    loginId: userId,
    passwordBefore: passwordBefore,
    passwordAfter: passwordAfter,
  }
  const result = await $http.post('/changeInitialPassword', parameters)
  return result.data.data
}

/**
 * パスワード初期化処理
 * @param {string} userId  ユーザーID
 * @param {string} mailAddress 登録メールアドレス
 * @returns {Object} サインインAPIレスポンス
 */
const passwordInitialization = async (userId, mailAddress) => {
  const $http = axios.create({
    baseURL: AUTHAPI_BASEURL,
    headers: {'Content-Type': 'application/json'},
    timeout: 15000
  })
  const parameters = {
    loginId: userId,
    mailAddress: mailAddress,
  }
  const result = await $http.post('/passwordInitialization', parameters)
  return result.data
}